<template>
  <v-data-table
    :headers="headers"
    :items="arr"
    height="auto"
    class="elevation-1"
    no-data-text="Sin resultados disponibles"
    fixed-header dense
    :footer-props="{
        'items-per-page-text': 'Elementos por página',
        'items-per-page-all-text': 'Todo',
        'items-per-page-options': [10],
      }"
  >
    <template v-slot:[`item.actions`]="{ index }">
      <v-tooltip v-if="isDelete" top>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            small
            class="mr-2"
            @click="deleteTreatment(index)"
            v-bind="attrs"
            v-on="on"
          >
            mdi mdi-delete
          </v-icon>
        </template>
        <span>Eliminar</span>
      </v-tooltip>
    </template>
    <template v-slot:[`item.guide`]="{ index }">
      <div>
        {{ index + 1 }}
      </div>
    </template>
    <template v-slot:[`item.selectTreatments`]="{ value }">
      <div>
        {{ value.map((obj) => obj.text).join(", ") }}
      </div>
    </template>
    <template v-slot:[`item.area`]="{ value }">
      <div v-for="(item, index) in value" :key="index">
        {{
          item === "1"
            ? "Hemiarcada superior derecha"
            : "" || item === "2"
            ? "Hemiarcada superior izquierda"
            : "" || item === "3"
            ? "Hemiarcada inferior izquierda"
            : "" || item === "4"
            ? "Hemiarcada inferior derecha"
            : ""
        }}
      </div>
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    arr: {
      type: Array,
    },
    deleteTreatment: Function,
  },
  data() {
    return {
      isDelete: true,
      headers: [
        { text: "#", value: "guide",align: "center" },
        { text: "Pieza dental", value: "mapId",align: "center" },
        { text: "Zona", value: "zoneName",align: "center" },
        { text: "Área", value: "area",align: "center" },
        { text: "Procedimiento", value: "selectTreatments", align: "center" },
        { text: "Acciones", value: "actions", sortable: false, width: "10%", align: "center" },
      ],
    };
  },
};
</script>
